import { Type } from '@angular/core';

import { GameScreenPage } from './features/game-screen/game-screen';
import { DailyCalendarPage } from './features/daily-calendar/daily-calendar';
import { DailyThemePage } from './features/daily-theme/daily-theme';
import { ThemePage } from './features/theme/theme';

/**
 * Registro central das telas carregadas dinamicamente via ScreenNavigationService
 * (fora do fluxo do Router). Para adicionar uma nova tela, basta registrar o
 * componente aqui com a mesma chave usada em `screenNavigation.navigate(...)` —
 * nenhum outro lugar precisa saber sobre a tela nova. Telas sem entrada aqui
 * (ex: 'home') caem no fallback via router-outlet, ver app.html.
 */
export const SCREEN_COMPONENTS: Record<string, Type<unknown>> = {
  theme: ThemePage,
  'daily-theme': DailyThemePage,
  'daily-calendar': DailyCalendarPage,
  game: GameScreenPage,
};
